/**
 * Celebration confetti helper.
 *
 * Uses canvas-confetti with the brand palette (blue-800 + amber-500 + white).
 * `celebrate()`  = big burst + trailing side-cannons for ~2s (used on
 *                 quiz-pass and certificate reveal).
 * `sparkle()`    = single quiet burst (used for micro wins).
 */
import confetti from "canvas-confetti";

const BRAND_COLORS = ["#1e3a8a", "#f59e0b", "#ffffff", "#fbbf24", "#3b82f6"];

export function celebrate() {
  // Big center burst
  confetti({
    particleCount: 140,
    spread: 90,
    startVelocity: 45,
    origin: { y: 0.6 },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
  });

  // Side cannons — staggered so it feels alive
  const shoot = (angle, x) => confetti({
    particleCount: 60,
    angle,
    spread: 55,
    startVelocity: 55,
    origin: { x, y: 0.7 },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
  });
  setTimeout(() => shoot(60, 0), 220);
  setTimeout(() => shoot(120, 1), 380);
  setTimeout(() => shoot(90, 0.5), 620);
}

export function sparkle() {
  confetti({
    particleCount: 40,
    spread: 60,
    origin: { y: 0.4 },
    colors: BRAND_COLORS,
    disableForReducedMotion: true,
  });
}
